import { useState, useEffect } from 'react'
import { Box, Grid, Stack, Text } from '@mantine/core'
import { getText } from '../utils/constants'
import { languages } from '../utils/languages'
import TitleDivider from './divider'
import { useLocaleContext } from '../context/locale'

function MoreDetails({ movie, title }) {
  const t = (key) => getText('MoreDetails', key)
  const { country } = useLocaleContext()
  const [isLocalProduction, setIsLocalProduction] = useState(false)

  useEffect(() => {
    if (movie.primary_country && country) {
      setIsLocalProduction(movie.primary_country.toLowerCase() === country)
    } else {
      setIsLocalProduction(false)
    }
  }, [movie.primary_country, country])

  return (
    <Box>
      <Stack spacing={0} mt={20}>
        <TitleDivider titleText={`MORE DETAILS ABOUT ${title.toUpperCase()}`} />
      </Stack>
      <Grid sx={{ fontSize: 14 }} mt={10} mb={30}>
        {/* Primera Columna */}
        <Grid.Col span={12} md={4}>
          <Stack spacing={24}>
            <TextDetails
              label={t('Spoken Languages')}
              content={
                movie.spoken_languages && movie.spoken_languages.length > 0
                  ? movie.spoken_languages.map((lang) => languages[lang]).join(', ')
                  : ''
              }
            />
            <TextDetails label={t('Type of Content')} content={movie.type} />
            <TextDetails
              label={t('Scripted')}
              content={movie.scripted === true ? 'True' : 'False'}
            />
            <TextDetails
              label={t('Content Age')}
              content={
                movie.age_ratings?.US && movie.age_ratings.US !== 'Approved'
                  ? movie.age_ratings.US
                  : t('notRated')
              }
            />
          </Stack>
        </Grid.Col>

        {/* Segunda Columna */}
        <Grid.Col span={12} md={4}>
          <Stack spacing={24}>
            <TextDetails
              label={t('Release Date')}
              content={
                movie.release_date
                  ? new Date(movie.release_date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })
                  : ''
              }
            />
            <TextDetails label={t('Hispanic')} content={movie.hispanic} />
            <TextDetails label={t('Status')} content={movie.status} />
            <TextDetails
              label={t('Alternative Titles')}
              content={
                movie.alternative_titles && movie.alternative_titles.length > 0
                  ? movie.alternative_titles
                      .map(
                        (title) =>
                          `${title.title} (${title.country} - ${title.language})`
                      )
                      .join(', ')
                  : t('notAvailable')
              }
            />
            <TextDetails
              label={t('Local Production')}
              content={isLocalProduction ? 'True' : 'False'}
            />
          </Stack>
        </Grid.Col>

        {/* Tercera Columna */}
        <Grid.Col span={12} md={4}>
          <Stack spacing={24}>
            <TextDetails
              label={t('Genres')}
              content={
                movie.genres && movie.genres.length > 0
                  ? movie.genres.join(', ')
                  : ''
              }
            />
            <TextDetails
              label={t('Keywords')}
              content={
                movie.keywords && movie.keywords.length > 0
                  ? movie.keywords.join(', ')
                  : ''
              }
            />
            <TextDetails
              label={t('Homepage')}
              content={
                movie.homepage ? (
                  <a href={movie.homepage} target="_blank" rel="noopener noreferrer">
                    {movie.homepage}
                  </a>
                ) : (
                  ''
                )
              }
            />
            <TextDetails
              label={t('Production Companies')}
              content={
                movie.production_companies && movie.production_companies.length > 0
                  ? movie.production_companies.join(', ')
                  : ''
              }
            />
          </Stack>
        </Grid.Col>
      </Grid>
    </Box>
  )
}

function TextDetails({ label, content }) {
  return (
    <Stack spacing={0} sx={{ minHeight: 60 }}>
      <Text c="dimmed">{label}</Text>
      <Text color="white">{content || 'No data available'}</Text>
    </Stack>
  )
}

export default MoreDetails
